module.exports = __webpack_public_path__ + "/content/skins/HDemo/fonts/3301D6_0_0.woff2";